import { Notify } from 'quasar';
import { i18n } from '@/plugins/i18n';
import { SavingError } from '@/errors';

const t = i18n.global.t;

export const wrapSavingOperation = async (
  saveCall: () => Promise<boolean>,
  onSuccess?: () => void,
  onFailure?: (error?: any) => void,
): Promise<void> => {
  try {
    const result = await saveCall();
    if (!result) {
      Notify.create({
        color: 'negative',
        message: t('global.notifications.errorSaving'),
        position: 'top',
        timeout: 2000,
      });
      if (onFailure) onFailure();
    } else {
      if (onSuccess) onSuccess();
    }
  } catch (error) {
    console.error(error);
    const explained = error instanceof SavingError;
    Notify.create({
      color: 'negative',
      message: explained ? error.message : t('global.notifications.errorSaving'),
      position: 'top',
      // Long enough to read a message that says what to fix.
      timeout: explained ? 6000 : 2000,
    });
    if (onFailure) onFailure(error);
  }
};
